/**
 * Utility functions for getting certification labels from assets
 */

import { DEFAULT_LABELS, DEFAULT_ROUTE_NAMES, MENU_LABELS } from "../../../constant";
import get from "lodash.get";

/**
 * Capitalize the first letter of a string
 */
function capitalizeFirst(str: string): string {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

export function getLabel(key: string, customLabels?: { [key: string]: string }, capitalize?: boolean): string {
  const label = get(customLabels, key) || get(DEFAULT_LABELS, key);
  return capitalize !== undefined ? (capitalize ? capitalizeFirst(label) : label.toLowerCase()) : label;
}

export function getMenuLabel(key: string, customLabels?: { [key: string]: string }): string {
  const label = get(customLabels, key) || get(MENU_LABELS, key);
  return label;
}

export function getUrl(key: string, customRouteNames?: { [key: string]: string }): string {
  const label = get(customRouteNames, key) ?? get(DEFAULT_ROUTE_NAMES, key) ?? "";
  return String(label).toLowerCase();
}